<div>

  <h1 id="app-title" class="eca-skip-link-focus-target" tabindex="-1">Security UI</h1>

  <p>App Name: {{ name }}</p>
  <p>Security Service Url: {{ securityServiceUrl }}</p>

  @if (user | async; as user) {
    <div>
      <p>
        <a class="btn btn-default" routerLink="/create-user">New User</a>
      </p>
      <p>Hello <strong class="username">{{user.firstName}} {{user.lastName}}</strong> to Security UI</p>
      <h3>User Payload</h3>
      <pre>{{ user | json }}</pre>
    </div>
  } @else {
    Loading your things...
  }
</div>
